import { Flame } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export default function PageNav() {
  const { pathname } = useLocation();
  return (
    <nav className="sticky top-0 z-40 backdrop-blur-xl bg-zinc-950/70 border-b border-white/[0.04]">
      <div className="max-w-5xl mx-auto flex items-center justify-between h-14 px-4">
        <Link to="/" className="flex items-center gap-2 text-burner-500 font-bold"><Flame size={20} /><span>Burner Codes</span></Link>
        <div className="flex items-center gap-1">
          {[{to:'/about',l:'About'},{to:'/faq',l:'FAQ'}].map(x=>(
            <Link key={x.to} to={x.to} className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${pathname===x.to?'text-gray-100 bg-white/[0.06]':'text-gray-400 hover:text-gray-200'}`}>{x.l}</Link>
          ))}
          <Link to="/login" className="ml-2 px-4 py-1.5 rounded-lg text-sm font-medium text-burner-400 border border-burner-500/20 hover:bg-burner-500/10 transition-colors">Try It</Link>
        </div>
      </div>
    </nav>
  );
}
